import { supabase } from '@/integrations/supabase/client';
import type { TopicSubscriberCounts, UserTopicSubscription } from '@/types/notifications';

/**
 * Fetch subscriber counts for all topics (admin use).
 * Calls the get_topic_subscriber_counts RPC.
 */
export async function getTopicSubscriberCounts(): Promise<TopicSubscriberCounts> {
  const { data, error } = await supabase.rpc('get_topic_subscriber_counts');

  if (error) throw error;

  const counts: TopicSubscriberCounts = {};
  for (const row of data || []) {
    counts[row.topic] = Number(row.subscriber_count);
  }
  return counts;
}

/**
 * Fetch a single user's topic subscriptions.
 */
export async function getUserTopicSubscriptions(
  userId: number
): Promise<UserTopicSubscription[]> {
  const { data, error } = await supabase
    .from('user_topic_subscriptions')
    .select('*')
    .eq('user_id', userId)
    .order('topic');

  if (error) throw error;
  return (data || []) as UserTopicSubscription[];
}

/**
 * Upsert a single topic subscription for a user.
 */
export async function updateTopicSubscription(
  userId: number,
  topic: string,
  isSubscribed: boolean
): Promise<void> {
  const { error } = await supabase
    .from('user_topic_subscriptions')
    .upsert(
      {
        user_id: userId,
        topic,
        is_subscribed: isSubscribed,
        subscribed_at: isSubscribed ? new Date().toISOString() : undefined,
        unsubscribed_at: isSubscribed ? null : new Date().toISOString(),
      },
      { onConflict: 'user_id,topic' }
    );

  if (error) throw error;
}
